export default "__VITE_ASSET__D7wDh6nb__"